import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=c5a7dd88&scoped=true"
import script from "./CampaignSummary.vue?vue&type=script&lang=js"
export * from "./CampaignSummary.vue?vue&type=script&lang=js"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&id=c5a7dd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a7dd88",
  null
  
)

export default component.exports